import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { onNavigateEvent } from 'analytics/performance'
import { ButtonContent } from 'components/styled/button/button-content'
import {
  BaseButtonProps,
  BaseButtonStyle,
  BaseButtonStyleProps,
  ButtonBox,
} from './base-button'

export interface LinkProps extends BaseButtonProps {
  to: string
}

export const StyledButtonLink = styled(Link)<BaseButtonStyleProps>`
  ${BaseButtonStyle};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`

export const LinkButton = ({
  loading = false,
  event,
  variant = 'primary',
  icon,
  useOutlinedIcon,
  svgIcon,
  text,
  size = 'default',
  label,
  to,
  ...props
}: LinkProps) => {
  const onLinkClick = () => {
    if (event) onNavigateEvent(event)
  }

  return (
    <ButtonBox {...props}>
      <StyledButtonLink
        $variant={variant}
        $size={size}
        $hasText={!!text}
        $loading={!!loading}
        aria-label={label}
        /* Link specific props */
        tabIndex={0}
        onClick={onLinkClick}
        to={to}
       // should new one have this? replace={false}
      >
        <ButtonContent
          variant={variant}
          icon={icon}
          useOutlinedIcon={useOutlinedIcon}
          svgIcon={svgIcon}
          text={text}
          loading={loading}
          size={size}
        />
      </StyledButtonLink>
    </ButtonBox>
  )
}
